import React, { useState } from 'react';
import { MonitorIcon } from 'lucide-react';
import AffiliateSteps from '../../components/Footer/AffiliateSteps';
import { useNavigate } from 'react-router-dom';

export default function AffiliateProgram() {
  const navigate = useNavigate();
  const [isChatOpen, setIsChatOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white relative">
      {/* Header */}
      <div className="bg-gradient-to-b from-[#021B36] to-[#1D2B8D] text-white py-6 md:py-10">
        <div className="container mx-auto flex flex-col md:flex-row items-center justify-between px-4 md:px-8 lg:px-32 h-auto md:h-[200px]">
          {/* Text Section */}
          <div className="text-center md:text-left mb-5 md:mb-0">
            <h2 className="text-[#e0ff27] font-bold font-nunito text-[16px] sm:text-[18px] md:text-[20px] tracking-widest">
              BOUNDLESS POSSIBILITIES
            </h2>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-[60px] font-bold mt-2">
              EARN COMMISSIONS
            </h1>
            <p className="text-gray-300 mt-2 text-xs sm:text-sm">
              BECOME A MY CODE Dragon AFFILIATE
            </p>
          </div>

          {/* Icon Section */}
          <div className="flex justify-center md:justify-end w-full md:w-1/2">
            <MonitorIcon
              size={100}
              className="w-32 sm:w-40 md:w-48 lg:w-64 xl:w-80 text-white"
            />
          </div>
        </div>
      </div>

      {/* Main content */}
      <main className="container mx-auto py-8 md:py-12 px-4 md:px-8">
        <h2 className="font-sans text-3xl sm:text-4xl md:text-[48px] font-bold mb-4 text-center text-navy-900">
          Join My Code Dragon Affiliate Program
        </h2>
        <p className="text-justify text-base sm:text-lg md:text-[20px] text-gray-600 mb-6 max-w-3xl mx-auto px-4 sm:px-0">
          My Code Dragon is looking for influencers in the coding community,
          whether you're a content creator, educator, or coding enthusiast, to
          help promote our platform as affiliate partners. Ideal candidates are:
          <ul className="list-disc list-inside mt-4 space-y-2">
            <li>
              Passionate about coding education and committed to helping
              students develop coding skills.
            </li>
            <li>
              Experienced content creators with an engaged audience interested
              in coding, STEM, or educational tools.
            </li>
            <li>
              Educators or mentors who are actively involved in teaching coding
              to students of all levels.
            </li>
          </ul>
          By partnering with My Code Dragon, affiliates can earn a 10%
          commission on all purchased subscriptions that remain active for at
          least one month, while also helping to inspire the next generation of
          coders.
        </p>
        <div className="flex justify-center my-4 md:my-5">
          <button
            onClick={() => navigate('/affiliate-form')}
            className="mt-4 px-3 py-2 sm:px-4 sm:py-2 text-lg sm:text-xl md:text-[24px] bg-[#1d2b8d] text-white rounded-md hover:bg-[#162169] transition-colors"
          >
            Apply to Become an Affiliate Partner
          </button>
        </div>
        {/* Benefits section */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-[60px] text-[#0A165B] font-nunito font-bold mb-4 md:mb-8 text-center text-navy-900">
          How does it work?
        </h2>

        {/* Steps section */}
        <AffiliateSteps />
      </main>

      {/* Chat Widget */}
    </div>
  );
}
